import { memo } from "react";
import { Flex } from "../../../../flex";
import { Text } from "../../../../text";
import { DAY_NAMES } from "../utils/date-picker-utils";

export const DayNamesHeader = memo(function DayNamesHeader() {
  return (
    <Flex dir="row" gap="none" p="none" w="full">
      {DAY_NAMES.map((day) => (
        <Flex
          align="center"
          gap="none"
          grow={1}
          justify="center"
          key={day}
          style={{ height: "40px" }}
        >
          <Text fontSize="sm" fontWeight="medium" textColor="secondary">
            {day}
          </Text>
        </Flex>
      ))}
    </Flex>
  );
});
